//TODO: is the parameter object consistent ?
/**
 * @function getFileName
 * @param  {Object} { path }
 * @return {String} File name
 */
export default function getFileName({ path }) {
  return path.split("/").pop();
}
